var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceExpertise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1204050",
    clipPath: "url(#clip0_29_23095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6306 50.6443C41.4761 50.1692 41.0653 49.823 40.5709 49.7511L35.4618 49.0087L33.177 44.3791C32.9558 43.9311 32.4996 43.6475 32 43.6475C31.5004 43.6475 31.0443 43.9311 30.823 44.3791L28.5383 49.0087L23.4291 49.7511C22.9348 49.823 22.524 50.1692 22.3695 50.6443C22.2153 51.1195 22.3439 51.6411 22.7016 51.9898L26.3986 55.5935L25.5259 60.682C25.4414 61.1743 25.6438 61.6721 26.048 61.9657C26.4523 62.2593 26.9881 62.2982 27.4303 62.0656L32 59.6631L36.5699 62.0656C36.7619 62.1666 36.9716 62.2163 37.1805 62.2163C37.4526 62.2163 37.7235 62.1318 37.9521 61.9657C38.3563 61.6721 38.5588 61.1743 38.4743 60.682L37.6015 55.5935L41.2985 51.9898C41.6563 51.6411 41.785 51.1196 41.6306 50.6443Z",
    fill: "url(#paint0_linear_29_23095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4048 50.6445C20.25 50.1692 19.8393 49.823 19.3449 49.7511L14.2358 49.0087L11.951 44.3791C11.7298 43.9311 11.2736 43.6475 10.774 43.6475C10.2744 43.6475 9.81825 43.9311 9.597 44.3791L7.31225 49.0087L2.20313 49.7511C1.70875 49.823 1.298 50.1692 1.1435 50.6443C0.989252 51.1195 1.11788 51.6411 1.47563 51.9898L5.17263 55.5936L4.3 60.6821C4.2155 61.1745 4.41788 61.6721 4.82213 61.9658C5.22613 62.2595 5.76213 62.2981 6.20438 62.0657L10.7741 59.6632L15.344 62.0657C15.536 62.1667 15.7458 62.2165 15.9546 62.2165C16.2268 62.2165 16.4976 62.132 16.7263 61.9658C17.1304 61.6722 17.3329 61.1745 17.2484 60.6821L16.3756 55.5936L20.0726 51.99C20.4304 51.6412 20.5591 51.1197 20.4048 50.6445Z",
    fill: "url(#paint1_linear_29_23095)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.8569 50.6442C62.7022 50.1692 62.2914 49.823 61.797 49.7511L56.6879 49.0087L54.4032 44.3791C54.1819 43.9311 53.7258 43.6475 53.2261 43.6475C52.7265 43.6475 52.2704 43.9311 52.0492 44.3791L49.7644 49.0087L44.6553 49.7511C44.1609 49.823 43.7502 50.1692 43.5957 50.6443C43.4414 51.1195 43.57 51.6411 43.9278 51.9898L47.6248 55.5935L46.752 60.682C46.6675 61.1743 46.8699 61.6721 47.2741 61.9657C47.5028 62.1318 47.7735 62.2163 48.0458 62.2163C48.2546 62.2163 48.4644 62.1666 48.6564 62.0656L53.2263 59.6631L57.796 62.0656C58.238 62.298 58.7739 62.2595 59.1783 61.9657C59.5824 61.6721 59.7849 61.1743 59.7004 60.682L58.8278 55.5935L62.5248 51.9897C62.8825 51.641 63.0113 51.1195 62.8569 50.6442Z",
    fill: "url(#paint2_linear_29_23095)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.2217 31.7495C45.2217 24.5132 39.333 18.625 32.0967 18.625C24.8608 18.625 18.9722 24.5132 18.9722 31.7495V41.1245H45.2217V31.7495Z",
    fill: "url(#paint3_linear_29_23095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.4717 9.24951C41.4717 4.08057 37.2656 -0.125 32.0967 -0.125C26.9277 -0.125 22.7222 4.08057 22.7222 9.24951C22.7222 14.4185 26.9277 18.6245 32.0967 18.6245C37.2656 18.6245 41.4717 14.4185 41.4717 9.24951Z",
    fill: "url(#paint4_linear_29_23095)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_23095",
    x1: 41.6949,
    y1: 34.363,
    x2: 22.3053,
    y2: 34.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_23095",
    x1: 20.469,
    y1: 34.363,
    x2: 1.07928,
    y2: 34.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_23095",
    x1: 62.9212,
    y1: 34.363,
    x2: 43.5314,
    y2: 34.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_23095",
    x1: 45.2217,
    y1: 7.37524,
    x2: 18.9722,
    y2: 7.37524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29_23095",
    x1: 41.4717,
    y1: -9.49976,
    x2: 22.7222,
    y2: -9.49976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_23095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceExpertise);
export default __webpack_public_path__ + "static/media/experience-expertise.0b98a800265810ea29a62754cef8104b.svg";
export { ForwardRef as ReactComponent };